export default __webpack_public_path__ + "static/efbaf613-e78b-4aed-bef6-b79bd8bedcdb-8f326f5a0f99eb0e201e6891c2f471af.woff2";